<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="箱号设置"
      class="customer-edit"
      width="400px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="sAPCustomerMaterialMapping"
        :rules="ruleValidate"
        class="form"
        label-width="40px">
      <el-form-item label="箱号">
        <el-input v-model="sAPCustomerMaterialMapping.packageNo" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>

  export default {
    name:"PackageNoEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        sAPCustomerMaterialMapping: {
          pkid: "",
          salesOrgan: "",
          salesChannel: "",
          customerNo: "",
          packageNo: "",
          customerMaterialNo: "",
          materialNo: "",
          customerMaterialDesc: "",
          unit: "",
          isDeleted: 0,
          createType: 0,
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        console.log(id);
        this.sAPCustomerMaterialMapping.pkid = id;
        this.dialogVisible = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `SAPCustomerMaterialMappings/${this.sAPCustomerMaterialMapping.pkid}`)
          .then(resp => {
            console.log(resp);
            this.sAPCustomerMaterialMapping = resp;
          });
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "SAPCustomerMaterialMappings", this.sAPCustomerMaterialMapping)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
